import styled from '@emotion/styled'
import { theme } from '../../themes/theme'
import { FlexColumn, SpaceBetweenRowContainer } from './Containers'

export const ExpandableRowContainer = styled(FlexColumn)`
  width: 100%;
  gap: 0;

  border-radius: ${theme.borderRadius.div};
  background: ${props => (props.active ? theme.colors.primaryExtraLight : theme.colors.background.white)};
  border: ${props => (props.active ? `1px solid ${theme.colors.primary}` : 'none')};
`

export const ActiveRow = styled(SpaceBetweenRowContainer)`
  text-wrap: wrap;
  word-break: break-word;
  padding: 15px 30px;

  :hover {
    cursor: pointer;
  }
`

export const InactiveRow = styled(ActiveRow)`
  border: 1px solid ${theme.colors.white};
  border-radius: ${theme.borderRadius.div};

  :hover {
    background: ${theme.colors.primaryLight};
    border: 1px solid ${theme.colors.primary};
  }
`

export const ExpandCollapseIconWrapper = styled.div`
  width: 29px;

  .MuiSvgIcon-root {
    height: 18px;
    width: 18px;
    transform: scale(1.6);
    padding-top: 2px;
  }
`

export const ExpandedContentWrapper = styled(FlexColumn)`
  padding: 0 30px 15px;
  gap: 15px;
`
